import { SUPPLY_TARGETING_TYPES } from '../../common-campaign-form/components/SupplyTargeting/const';

export const isAppleTargeting = campaign =>
    campaign?.campaignTargeting?.supplyTargeting === SUPPLY_TARGETING_TYPES.APPLE_NEWS;
